import { FC, useEffect, useMemo, useState } from "react";
import { WorkTgSelector } from "../../../features/workTgSelector";
import { workTgService } from "../../../entities/workTg";
import { IItem } from "../../../shared/model/types";
import classes from "./workTgFilter.module.scss";

interface IProps {
    label?: string;
    setWorkTgIds: (workTgIds: number[]) => void;
    initWorkTgIds?: number[];
}

export const WorkTgFilter: FC<IProps> = ({label = 'Рабочий ТГ:', setWorkTgIds, initWorkTgIds}) => {
    const [selectedItems, setSelectedItems] = useState<IItem[]>([])
    const normalizedInitWorkTgIds = useMemo(
        () => (initWorkTgIds ?? []).filter(id => !isNaN(id)),
        [initWorkTgIds?.join(',')]
    )
    const normalizedInitKey = useMemo(() => normalizedInitWorkTgIds.join(','), [normalizedInitWorkTgIds])

    useEffect(() => {
        if(normalizedInitWorkTgIds.length === 0){
            setSelectedItems([])
            return
        }

        setSelectedItems(prev => {
            const next = normalizedInitWorkTgIds.map(id => {
                const currentItem = prev.find(item => item.id === id)
                return currentItem || {id, name: `ID ${id}`}
            })

            if(prev.length === next.length && prev.every((item, index) => item.id === next[index].id)){
                return prev
            }

            return next
        })
    }, [normalizedInitKey])

    const onChange = (items: IItem[]) => {
        setSelectedItems(items)
        setWorkTgIds(items.map(item => item.id))
    }

    return (
        <section className={classes.container}>
            <span className={classes.label}>{label}</span>
            <section className={classes.selector}>
                <WorkTgSelector
                    selectedItems={selectedItems}
                    onChange={onChange}
                    getData={async () => {
                        const workTgs = await workTgService.getAll()
                        return workTgs.map(workTg => ({id: workTg.id, name: workTg.name}))
                    }}
                    multiple
                    placeholder="Выберите рабочий ТГ"
                />
            </section>
        </section>
    )
}
